import Image from 'next/image';
import { useDispatch } from 'react-redux';

import { SliderWrapper } from '@/components/ui';
import { actions } from '@/domains/mini-market';

import styles from './index.module.scss';

export const ImageSlider = ({ images, setModalActive, data }) => {
  const dispatch = useDispatch();
  const clickHandler = (image) => {
    setModalActive(true);
    dispatch(actions.setSelectedImage(image));
  };
  return (
    <SliderWrapper
      className={styles.customSlider}
      arrows
      options={{ infinite: true }}
      itemScope
      itemType='https://schema.org/ImageGallery'
    >
      {images.map((image) => {
        return (
          <div
            onClick={() => clickHandler(image)}
            key={image}
            className={styles.sliderImage}
          >
            <Image
              src={image}
              width={475}
              height={475}
              alt={data?.name}
              title={data?.name}
            />
          </div>
        );
      })}
    </SliderWrapper>
  );
};
